import { css } from '@/styled-system/css';

export const streetViewContainer = css({
  position: 'absolute',
  inset: 0,
});

export const streetViewError = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'hpxGrey100',
  color: 'hpxGrey600',
  fontSize: 'md',
  textAlign: 'center',
  gap: 'xs',
});

export const streetViewErrorBold = css({
  fontWeight: '700',
});
